
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"var(--barnd-pr-cl-deep)"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 12h5a1.99 1.99 0 011.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 0112 21v-5a4 4 0 014-4zm2.409 5.348a.75.75 0 00-1.06 1.061L18.938 20l-1.59 1.591a.75.75 0 101.06 1.06L20 21.062l1.591 1.59a.75.75 0 101.06-1.06L21.062 20l1.59-1.591a.75.75 0 00-1.06-1.06L20 18.938l-1.591-1.59z","fill":"var(--brand-primary-lighter)"}})])
          )
        }
      }
    